import {NgModule} from '@angular/core';
import {ListComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {JsonPipe, NgClass, NgForOf, NgIf, NgStyle, NgTemplateOutlet} from '@angular/common';
import {IconComponentModule} from '../icon/item.module';
import {LoaderComponentModule} from '../loader/item.module';
import {EmptyOrNoAccessComponentModule} from '../empty-or-noaccess/item.module';
import { PipesModule } from "app/core/pipes/pipes.module";

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    NgForOf,
    NgTemplateOutlet,
    IconComponentModule,
    LoaderComponentModule,
    EmptyOrNoAccessComponentModule,
    PipesModule,
    JsonPipe
  ],
  exports: [
    ListComponent
  ],
  declarations: [ListComponent],
  providers: [],
})
export class ListComponentModule {
}
